// extracted by mini-css-extract-plugin
export default {"container":"VJ-z","topReviewHeading":"WJ-z","criticalReview":"XJ-z","favorableReview":"YJ-z","vsSeparator":"ZJ-z"};